<template>
  <FlexLayout col :gap="12">
    <p class="font-medium">結帳明細</p>

    <!-- keeper -->
    <div v-if="showControl.keeperVehicle">
      <Tag class="keeper-vehicle-size-tag" type="info">
        車型尺寸：{{ displayData.keeperVehicle.size }}
      </Tag>
    </div>

    <div v-loading="loading.checkoutDetail" class="flex flex-col" style="gap: 24px">
      <AppointmentCheckoutReceipt />

      <div v-show="showControl.checkoutPrice" class="flex items-center justify-between">
        <p>{{ displayData.totalPriceTitle }}</p>
        <p class="text-primary-100">$ {{ displayData.totalPrice }}</p>
      </div>
    </div>
  </FlexLayout>
</template>

<script>
import { computed, defineComponent } from 'vue'
import AppointmentCheckoutReceipt from './AppointmentCheckoutReceipt.vue'
import { useCreateAppointment } from '@/use/useCreateAppointment'
import { get } from 'lodash'

export default defineComponent({
  name: 'AppointmentCheckoutDetailBlock',
  components: {
    AppointmentCheckoutReceipt,
  },
  setup (props, { emit }) {
    const { context, orderCheckoutPrice, loading } = useCreateAppointment()
    const chargeType = computed(() => get(context.checkoutDetail, 'chargeType'))
    const displayData = computed(() => {
      let totalPriceTitle = '實付金額'

      if (chargeType.value === 'deposit') {
        totalPriceTitle = '實付定金'
      }

      return {
        totalPriceTitle,
        totalPrice: orderCheckoutPrice.value,
        keeperVehicle: {
          size: get(context.vehicleInfoDetail, 'size', '-'),
        },
      }
    })

    const showControl = computed(() => {
      const controls = {
        checkoutReceipt: true,
        checkoutPrice: true,
        keeperVehicle: false,
      }

      if (chargeType.value === 'none' || chargeType.value === 'deposit') {
        controls.checkoutReceipt = false
      }

      if (chargeType.value === 'none') {
        controls.checkoutPrice = false
      }

      // keeper 車輛資訊
      if (get(context.vehicleInfoDetail, 'vehicle')) {
        controls.keeperVehicle = true
      }

      return controls
    })
    return { displayData, context, loading, showControl }
  },
})
</script>

<style lang="postcss" scoped>
.keeper-vehicle-size-tag {
  /* @apply border */
}
</style>
